// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
import { ReportGroupResponseMessage } from '../Messages/ReportGroupResponseMessage';
export class ReportGroupResponseMessageProcessor extends MessageProcessorBase {
    constructor() {
        super(...arguments);
        this.MsgArr = [];
    }
    decode(fieldSet) {
        const msg = new ReportGroupResponseMessage(fieldSet);
        this.MsgArr.push(msg);
        const responseEnd = fieldSet.GetField(FieldsFactory.FIELD_RESPONCE_END);
        if (responseEnd) {
            msg.RelatedMessages = this.MsgArr;
            this.MsgArr = [];
        }
        return responseEnd ? [msg] : [];
    }
}
